/* Author : Nitish Hardeniya */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';

const NoContent = props => {
  const { placement, containerHeight, icon, message } = props;
  return (
    <Grid
      container
      direction="column"
      justify={placement}
      alignItems="center"
      className="no-content"
      style={{ height: containerHeight }}
    >
      <Grid item xs={12}>
        <div>
          <img src={icon} alt="no content" />
        </div>
        <div className="body normal padding-t-10 padding-b-20 text-newline">
          {message}
        </div>
      </Grid>
    </Grid>
  );
};

export default NoContent;

NoContent.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.string,
  containerHeight: PropTypes.string,
  placement: PropTypes.string,
};
